import { InputRule } from "@tiptap/core";
import TaskItem from "@tiptap/extension-task-item";
import TaskList from "@tiptap/extension-task-list";

/** Readers are unconditional. Creation permission is checked at the moment of
 * input so admin preview changes do not require rebuilding a collaborative editor.
 * Existing checklist editing (Enter, nesting, checkbox clicks) stays available. */
export function createTaskListExtensions({ canWrite }: { canWrite: boolean | (() => boolean) }) {
  const allowed = () => typeof canWrite === "function" ? canWrite() : canWrite;
  const list = TaskList.extend({
    addStorage: () => ({ get canWrite() { return allowed(); } }),
    addKeyboardShortcuts() {
      const shortcuts = this.parent?.() ?? {};
      return Object.fromEntries(Object.entries(shortcuts).map(([key, command]) => [
        key, (...args: Parameters<typeof command>) => allowed() && command(...args),
      ]));
    },
  });
  const item = TaskItem.extend({
    addInputRules() {
      return (this.parent?.() ?? []).map(rule => new InputRule({
        find: rule.find,
        handler: props => allowed() ? rule.handler(props) : null,
      }));
    },
  }).configure({ nested: true });
  return [list, item];
}
